import { useContext } from "react";

import { TooltipsContext } from "./TooltipsContext";

export function useTooltips() {
  const context = useContext(TooltipsContext);
  if (!context) {
    throw new Error("useTooltips must be used within a TooltipsProvider");
  }
  return context;
}
